import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import AssignedAssetsForm from "./AssignedAssetsForm";
import PopupButton from "components/button/PopupButton";
import Crudoption from "components/dropdown/crudoption";

const AssignedAssetsTable = ({
	recordList,
	employeeId 
}) => {
	
  	const columns = [
		{
			title: 'Asset No.',
			dataIndex: 'eaa_asset_id',
			key: 'eaa_asset_id',
			width: '12%',
			render: (text) => <span>{text}</span>
		},
		{
			title: 'Equipment Name',
			dataIndex: 'asset_name',
			key: 'asset_name',
			width: '20%',
			render: (text) => <span>{text}</span>
		},
		{
			title: 'Equipment Type',
			dataIndex: 'asset_type',
			key: 'asset_type',
			width: '15%',
			render: (text) => <span>{text}</span>
		},
		{
			title: 'Condition Issued',
			dataIndex: 'asset_condition_name',
			key: 'asset_condition_name',
			width: '15%',
			render: (text) => <span>{text}</span>
		},
		{
			title: 'Date Provided',
			dataIndex: 'eaa_date_provided',
			key: 'eaa_date_provided',
			width: '12%',
			render: (text) => <span>{text}</span>
		},
		{
			title: 'Date Returned',
			dataIndex: 'eaa_date_returned',
			key: 'eaa_date_returned',
			width: '12%',
			render: (text) => <span>{text || '-'}</span>
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			width: '10%',
			render: (text) => <span>{text}</span>
		},
		{
			title: <PopupButton id="add_employee_schedule" title="Add Schedule" label="Add" btnClass="btn-small">
						<AssignedAssetsForm recordId={0} mode="edit" employeeId={0} />
					</PopupButton>,
			dataIndex: 'eaa_id',
			key: 'eaa_id',
			width: '12%',
			render:(_, record) => <Crudoption 
										baseRoute={`/console/employees/${employeeId}/assigned-assets`} 
										recordId={record?.esd_id} 
										allowEdit={false} 
										viewMode="modal"
										title="Edit Assigned Assets"
									/>
		},
	];

	// useEffect(() => {
	// 	if (employeeId) {
	// 		doSearch({paginate: pagination.per_page, employeeId});
	// 	} 
	// }, [doSearch, employeeId, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignedAssetsTable);